import React, {useState} from "react"
import {HoldButton, notificationService} from "../../shared";


class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false, errorMessage: ''};
    }

    static getDerivedStateFromError(error) {
        return {hasError: true, errorMessage: error.message};
    }

    componentDidCatch(error, errorInfo) {
        notificationService.error(`Критична помилка: ${error.message}`, 10000);
    }

    resetError = () => {
        this.setState({hasError: false, errorMessage: ''});
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{background: "lightblue", width: "100%", height: "100dvh", display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <div style={{textAlign: 'center'}}>
                        <h2>Щось пішло не так.</h2>
                        <p>{this.state.errorMessage}</p>
                        <HoldButton onAction={this.resetError} style={{background: 'var(--color-primary, blue)', color: 'white', padding: '10px 20px'}}>
                            Спробувати ще раз
                        </HoldButton>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}


// Пример компонента, который может выбросить ошибку
function BuggyComponent() {
    const [count, setCount] = useState(0)
    const increment = () => {
        setCount(p => p += 1)
    }

    if (count === 2) throw new Error("Тестова помилка " + count)

    return (
        <>
            <div>Цей компонент працює нормально.</div>
            <HoldButton onAction={increment}
                        style={{fontSize: "1.2rem", color: "white", background: "blue"}}>
                Викликати помилку (клікніть двічі): {count}
            </HoldButton>
        </>
    )
}

export {ErrorBoundary, BuggyComponent}
